import { render, staticRenderFns } from "./GroupEntityDetails.vue?vue&type=template&id=1ab2c2d0"
import script from "./GroupEntityDetails.vue?vue&type=script&lang=js"
export * from "./GroupEntityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ab2c2d0')) {
      api.createRecord('1ab2c2d0', component.options)
    } else {
      api.reload('1ab2c2d0', component.options)
    }
    module.hot.accept("./GroupEntityDetails.vue?vue&type=template&id=1ab2c2d0", function () {
      api.rerender('1ab2c2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupEntityDetails.vue"
export default component.exports